<template>
  <div class="container">
    <div class="section clearfix"></div>
    <div class="row justify-content-center">
      <div class="col-md-8 align-self-center">
        <div class="subtitle with-line text-center mb-4">luxury</div>
        <h3 class="text-center padding-bottom-small">Our rooms</h3>
      </div>
      <div class="col-md-6 mt-4" v-for="room in guestRooms" :key="room.id">
        <div class="room-box background-white">
          <div class="room-name">{{ room.name }}</div>
          <div class="room-per">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <img :src="room.image_url" alt>
          <div class="room-box-in">
            <h5 class>{{ room.name }}</h5>
            <p
              class="mt-3" v-html="room.description"
            >{{ room.description }}</p>
            <a class="mt-1 btn btn-primary" href="#" @click="bookRoomNow($event, room.id)">Check Availabilty</a>
            <div class="room-icons mt-4 pt-4">
              <img src="img/5.svg" alt>
              <img src="img/2.svg" alt>

              <img src="img/1.svg" alt>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-6 mt-4 mt-md-0">
        <div class="room-box background-white">
          <div class="room-name">Deluxe Twin</div>
          <div class="room-per">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star-o"></i>
          </div>
          <img src="img/rooms/deluxe-twin/1.jpg" alt>
          <div class="room-box-in">
            <h5 class>Deluxe Polo View</h5>
            <p
              class="mt-3"
            >Spacious and light-filled, the Two Bed are as versatile as our guests needs. Featuring two spacious beds, they are an ode to gracious living, inspiring a profound sense of freedom and comfort Enjoy spanning city views from any of our King or Twin rooms and spend time with family and friends.</p>
            <a class="mt-1 btn btn-primary" href="#" @click="bookNow($event)">book from $253.13</a>
            <div class="room-icons mt-4 pt-4">
              <img src="img/4.svg" alt>
              <img src="img/2.svg" alt>
              <img src="img/6.svg" alt>

            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="col-md-6 mt-4">
        <div class="room-box background-white">
          <div class="room-name">Executive City View</div>
          <div class="room-per">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <img src="img/rooms/executive-city/1.jpg" alt>
          <div class="room-box-in">
            <h5 class>Executive City View</h5>
            <p
              class="mt-3"
            >[ missing info ] Spacious and light-filled, the Two Bed are as versatile as our guests needs. Featuring two spacious beds, they are an ode to gracious living, inspiring a profound sense of freedom and comfort Enjoy spanning city views from any of our King or Twin rooms and spend time with family and friends.</p>
            <a class="mt-1 btn btn-primary" href="#" @click="bookNow($event)">book from $525.72</a>
            <div class="room-icons mt-4 pt-4">
              <img src="img/5.svg" alt>
              <img src="img/2.svg" alt>

              <img src="img/6.svg" alt>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="col-md-6 mt-4">
        <div class="room-box background-white">
          <div class="room-name">Executive Polo View</div>
          <div class="room-per">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <img src="img/rooms/executive-polo/1.jpg" alt>
          <div class="room-box-in">
            <h5 class>Executive Polo view</h5>
            <p
              class="mt-3"
            >Charming, light-filled and elegant, with amazing Port Harcourt City view, our Bedroom Suite are thoughtfully designed with a high-end selection of materials and furniture that balance perfectly between homey and deluxe, in order to provide a profound feeling of relaxation and comfort for our guests.</p>
            <a class="mt-1 btn btn-primary" href="#" @click="bookNow($event)">Check Availabilty</a>
            <div class="room-icons mt-4 pt-4">
              <img src="img/5.svg" alt>
              <img src="img/2.svg" alt>

              <img src="img/6.svg" alt>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-6 mt-4">
        <div class="room-box background-white">
          <div class="room-name">Diplomatic Suite</div>
          <div class="room-per">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <img src="img/rooms/diplomatic-suite/1.jpg" alt>
          <div class="room-box-in">
            <h5 class>Diplomatic Suite</h5>
            <p
              class="mt-3"
            >[ missing info ] Spacious and light-filled, the Two Bed are as versatile as our guests needs. Featuring two spacious beds, they are an ode to gracious living, inspiring a profound sense of freedom and comfort Enjoy spanning city views from any of our King or Twin rooms and spend time with family and friends.</p>
            <a class="mt-1 btn btn-primary" href="#" @click="bookNow($event)">book from $753.81</a>
            <div class="room-icons mt-4 pt-4">
              <img src="img/5.svg" alt>
              <img src="img/2.svg" alt>

              <img src="img/6.svg" alt>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-6 mt-4">
        <div class="room-box background-white">
          <div class="room-name">Presidential Suite</div>
          <div class="room-per">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
          </div>
          <img src="img/rooms/presidential-suite/1.jpg" alt>
          <div class="room-box-in">
            <h5 class>Presidential Suite</h5>
            <p
              class="mt-3"
            >[ missing info ] Spacious and light-filled, the Two Bed are as versatile as our guests needs. Featuring two spacious beds, they are an ode to gracious living, inspiring a profound sense of freedom and comfort Enjoy spanning city views from any of our King or Twin rooms and spend time with family and friends.</p>
            <a class="mt-1 btn btn-primary" href="#" @click="bookNow($event)">book from $1165.49</a>
            <div class="room-icons mt-4 pt-4">
              <img src="img/5.svg" alt>
              <img src="img/2.svg" alt>

              <img src="img/6.svg" alt>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import Constants from "@/common/Constants.js";

export default {
  name: "headerNav",
  data(){
    return {
      guestRooms : {},
      room:{}
    }
  },
  created() {
    cbpAnimatedHeader = (function() {
      function e() {
        window.addEventListener(
          "scroll",
          function(e) {
            c || ((c = !0), setTimeout(n, 250));
          },
          !1
        );
      }

      function n() {
        var e = s();
        e >= i
          ? classie.add(t, "cbp-af-header-shrink")
          : classie.remove(t, "cbp-af-header-shrink"),
          (c = !1);
      }

      function s() {
        return window.pageYOffset || a.scrollTop;
      }
      var a = document.documentElement,
        t = document.querySelector(".cbp-af-header"),
        c = !1,
        i = 100;
      e();
    })();

    this.getRooms();
  },
  methods: {
    openLoginModal() {
      $("#loginRegisterModal").modal("toggle");
    },
    bookNow(event){
      event.preventDefault();
      this.$router.push('/booking-form');
    },

    getRooms(){
      this.$http
        .get(Constants.API_GET_ROOMS_URL)
        .then(response => {
            this.guestRooms = response.data.guestRooms;
        })
        .catch(function(error) {
            if (error.response) {
              console.log(error);
             
            }
        });
    },

    bookRoomNow(event, roomId){
       event.preventDefault();
       localStorage.queryData = '';
       localStorage.rooms = '';
        this.$router.push('rooms');
      
    },

    // selectRoom($event, id){
    //   this.room = this.rooms.find(obj => obj.id == id);
    //   localStorage.room = JSON.stringify(this.room);
    //   this.$router.push('book-details');

    // }

  },
  props: {
    msg: String
  }
};
</script>

